import { Link } from 'react-router-dom'
import { IconComponent, Navbar } from '@workwhile/web-ui'
import { track } from 'lib/amplitude'

interface NavLinkProps {
  to: string
  icon: IconComponent
  text: string
  selected?: boolean
}

export const NavLink = (props: NavLinkProps) => {
  const { to, icon, text, selected } = props

  const onLinkClick = () => {
    track(`button_click, ${to.replace(/^\//, '')}`)
  }

  return (
    <Navbar.Item
      component={Link}
      to={to}
      label={text}
      leftIcon={icon}
      active={selected}
      onClick={onLinkClick}
    />
  )
}
